import React from 'react';
import PropTypes from 'prop-types';

import { BLACK } from '@constant/colors';

const More = ({ className, color, onClick }) => (
  <svg className={className} onClick={onClick} viewBox="638 36 18 18">
    <path
      d="M647 47c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm7 0c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm-14 0c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

More.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

More.defaultProps = {
  color: BLACK,
};

export default More;
